import { Ticker } from "pixi.js";
import { Mesh, MeshBasicMaterial, Object3D } from "three";
import { Tween } from "@tweenjs/tween.js";

export class GloryHole extends Object3D {
    private tween: Tween;

    public constructor(
        private readonly holeMesh: Mesh,
        private readonly openScale: number = 1
    ) {
        super();
        const holeMaterial = this.holeMesh.material as MeshBasicMaterial;
        holeMaterial.transparent = true;
        this.add(holeMesh);
        this.position.y += 0.01;
        this.scale.set(0, 0, 0);
        Ticker.shared.add(this.update, this);
    }

    public open(durationMs: number = 100): Promise<void> {
        this.tween = new Tween(this.scale);
        this.tween.to({ x: this.openScale, y: this.openScale, z: this.openScale }, durationMs).start();
        return new Promise((resolve, _reject) => {
            this.tween.onComplete(() => {
                this.tween.onComplete(null);
                this.tween.stop();
                this.tween = null;
                resolve();
            });
        });
    }

    public close(durationMs: number = 100): Promise<void> {
        this.tween = new Tween(this.scale);
        this.tween.to({ x: 0, y: 0, z: 0 }, durationMs).start();
        return new Promise((resolve, _reject) => {
            this.tween.onComplete(() => {
                this.tween.onComplete(null);
                this.tween.stop();
                this.tween = null;
                resolve();
            });
        });
    }

    private update(): void {
        if (this.tween?.isPlaying()) {
            this.tween.update();
        }
    }

    public destroy(): void {
        this.tween?.end();
        Ticker.shared.remove(this.update, this);
    }
}